import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashGoogleMapComponent } from './dash-google-map.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    DashGoogleMapComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports:[
    DashGoogleMapComponent
  ]
})
export class DashGoogleMapModule { }
